import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      await authService.forgotPassword(email);
      setMessage('Si el correo electrónico está registrado, recibirás un enlace para restablecer tu contraseña en los próximos minutos.');
      setEmail('');
    } catch (err) {
      console.error('Forgot password error:', err);
      setError('Hubo un problema al procesar tu solicitud. Por favor, intenta de nuevo más tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif', backgroundColor: '#e6f0e9', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: '450px', width: '100%' }}>
        <img src="/Logo-Andromeda.png" alt="Logo" style={{ width: '80px', marginBottom: '20px' }} />
        <div style={{ padding: '30px', border: '1px solid #e0e0e0', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', backgroundColor: '#fff' }}>
          <h2 style={{ color: '#007A33', marginBottom: '20px' }}>Recuperar Contraseña</h2>
          <p style={{ color: '#666', marginBottom: '25px', fontSize: '0.95em' }}>
            Introduce tu correo electrónico y te enviaremos las instrucciones para restablecer tu acceso.
          </p>

          {message && (
            <div style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f', color: '#389e0d', padding: '15px', borderRadius: '5px', marginBottom: '20px', fontSize: '0.9em', textAlign: 'left' }}>
              {message}
            </div>
          )}

          {error && (
            <div style={{ backgroundColor: '#fff1f0', border: '1px solid #ffa39e', color: '#cf1322', padding: '15px', borderRadius: '5px', marginBottom: '20px', fontSize: '0.9em', textAlign: 'left' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <input
              type="email"
              placeholder="tu@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              style={{ padding: '12px', fontSize: '1em', borderRadius: '5px', border: '1px solid #007A33' }}
            />
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '12px',
                fontSize: '1.1em',
                backgroundColor: '#007A33',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                transition: 'opacity 0.3s'
              }}
            >
              {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
            </button>
          </form>

          <button
            onClick={() => navigate('/')}
            style={{ background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', fontSize: '0.95em', textDecoration: 'underline', marginTop: '20px' }}
          >
            Volver al Inicio de Sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;